import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { firstValueFrom } from "rxjs";
import { Feedback, FeedbackSearchCriteria, FeedbackStatus, PaymentSearchCriteria, SearchResults } from "../model/common.model";

@Injectable({
  providedIn: "root"
})
export class FeedbackService {
  constructor(private http: HttpClient) { }

  search(criteria: FeedbackSearchCriteria) {
    return firstValueFrom(this.http.post<SearchResults<any>>(`/api/feedback/search`, criteria));
  }
  
  setStatus(id: string, status: FeedbackStatus) {
    return firstValueFrom(this.http.post<Feedback>(`/api/feedback/set-status`, { id, status }));
  }

  mine(criteria: FeedbackSearchCriteria) {
    return firstValueFrom(this.http.post<SearchResults<any>>(`/api/feedback/mine`, criteria));
  }
  submitFeedback(feedback: Feedback) {
    return firstValueFrom(this.http.post<Feedback>(`/api/feedback/submit`, feedback));
  }
  save(feedback: Feedback) {
    return firstValueFrom(this.http.post<Feedback>(`/api/feedback/save`, feedback));
  }

}
